import { A11y, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import { Image, Svg } from '../../../snippets';
import { ProductImage } from './ProductImage';

import { useOpenMediaModal } from './useOpenMediaModal';

export function ProductMediaSlider({
  memoizedProductMedia,
  onSwiper,
  onSlideChange,
  navigation = false,
}) {
  const { handleModal } = useOpenMediaModal();

  return (
    <Swiper
      modules={[A11y, Pagination]}
      slidesPerView={1}
      grabCursor
      centeredSlides
      loop
      lazy={{
        loadPrevNext: true,
      }}
      navigation={navigation}
      onSwiper={onSwiper}
      onSlideChange={(s) => onSlideChange?.(s.realIndex)}
    >
      {memoizedProductMedia?.map((media, index) => {
        const { mediaContentType, image, product, sources, preview } = media;
        const previewSrc = image?.src;

        return (
          <SwiperSlide key={index}>
            <div>
              {mediaContentType === 'VIDEO' ? (
                // <ProductVideo media={media} />
                <button
                  className="relative aspect-square w-full bg-[#E6F0F8]"
                  type="button"
                  aria-label="Open video in modal"
                  onClick={() => {
                    handleModal({
                      videoSources: sources,
                      openInFullscreen: true,
                    });
                  }}
                >
                  <Image
                    alt={product.title}
                    fill
                    sizes="(min-width: 1440px) 500px, (min-width: 768px) 50vw, 100vw"
                    priority={index < 2}
                    src={preview?.image?.src || previewSrc}
                  />

                  <div className="absolute bottom-[30px] right-[30px] flex h-[47px] w-[47px] items-center justify-center rounded-full bg-gradient-to-t from-[#8DCEF9] to-[#C1EFFA]">
                    <div className="flex h-full w-full scale-95 items-center justify-center rounded-full bg-white">
                      <Svg
                        className="w-[14px] text-textLink"
                        src="/svgs/play.svg#play"
                        title="Play"
                        viewBox="0 0 24 24"
                      />
                    </div>
                  </div>
                </button>
              ) : (
                <ProductImage media={media} priority={index === 0} />
              )}
            </div>
          </SwiperSlide>
        );
      })}
    </Swiper>
  );
}
